import { Chicken } from "../types/Chicken";
import { ChickenSvg } from "./ChickenSvg";

export const ChickenItem = ({chicken, image_url, annotation_value, user_id}: {chicken: Chicken, image_url: string, annotation_value: bool, user_id: integer}) => {
  return (
    <>
    <div className="bg-gray-200 group relative mb-4 p-4 rounded-md">
      <div className="bg-white rounded-md group-hover:opacity-75 flex h-[350px] mx-auto flex justify-center overflow-hidden">
        <img src={image_url} className="object-contain h-full" />
      </div>
      <div className="mt-4 justify-between">
        <h3 className="text-sm text-gray-700">
          <div>
            <a href={chicken.attributes.url_path} className="flex justify-center">
              <span aria-hidden="true" className="absolute inset-0"></span>
              {user_id == chicken.attributes.user_id?<ChickenSvg className="max-h-5 max-w-5 mx-2" />:''}
              <span>{annotation_value ? chicken.attributes.value : chicken.attributes.name}</span>
            </a>
          </div>
        </h3>
      </div>
    </div>
    </>
  );
};
